import { useEffect, useState } from "react";
import { CustomCode } from "@/components/CustomCode/CustomCode";
import { generateAiContextBlock } from "@/utils/generateAiContextBlock";
import { DEFAULT_ORIGIN } from "@/utils/server/publicSiteOrigin";

export const AiCopyPasteBlock = () => {
  const [markdown, setMarkdown] = useState(() => generateAiContextBlock(DEFAULT_ORIGIN));

  useEffect(() => {
    setMarkdown(generateAiContextBlock(window.location.origin));
  }, []);

  return <CustomCode className="language-text">{markdown}</CustomCode>;
};
